module.exports = __webpack_public_path__ + "media/images/size-guide-img1-2c51ea76b76e721e9710ec2874ef32c2.png";